import bharatBg from '../../assets/clients_journey/bharat_bhoudhiks.png';
import ecoBg from '../../assets/clients_journey/eco_clubs.png';

// Static data for Clients Journey page
export interface JourneyStep {
  id: number;
  title: string;
  subtitle: string;
  description: string[];
  icon: string;
}

export interface ClientCollaboration {
  id: number;
  name: string;
  organizationType: 'Educational' | 'Government' | 'Initiative' | 'Institutional' | 'Higher Education Institution' | 'Educational Platform' | 'Government Examination Authority' | 'Environmental Initiative';
  collaborationFocus: string;
  projectNature: 'Pilot' | 'Ongoing' | 'Program-based' | 'Pilot / Limited Scope';
  summary: string;
  highlights: string[];
  impact: string;
  logo?: string;
  backgroundImage?: string;
  theme?: {
    gradient: string;
    glow: string;
    accent: string;
  };
}

export const journeySteps: JourneyStep[] = [
  {
    id: 1,
    title: "Initial Engagement",
    subtitle: "Understanding Client Vision",
    description: [
      "Client consultation and requirement gathering",
      "Understanding organizational goals and objectives",
      "Identifying collaboration opportunities",
      "Defining project scope and deliverables"
    ],
    icon: "🤝"
  },
  {
    id: 2,
    title: "Project Planning",
    subtitle: "Strategic Collaboration Design",
    description: [
      "Detailed project roadmap development",
      "Resource allocation and team formation",
      "Technology and platform selection",
      "Timeline and milestone planning"
    ],
    icon: "📋"
  },
  {
    id: 3,
    title: "Solution Architecture",
    subtitle: "Custom Platform Development",
    description: [
      "Tailored digital platform design",
      "Scalable architecture planning",
      "Integration requirements analysis",
      "User experience optimization"
    ],
    icon: "🎯"
  },
  {
    id: 4,
    title: "Implementation",
    subtitle: "Building Digital Solutions",
    description: [
      "Platform development and deployment",
      "Feature implementation and testing",
      "Quality assurance and validation",
      "Continuous client feedback integration"
    ],
    icon: "⚡"
  },
  {
    id: 5,
    title: "Quality Validation",
    subtitle: "Excellence in Delivery",
    description: [
      "Comprehensive testing and validation",
      "Performance optimization",
      "Security and compliance checks",
      "User acceptance testing"
    ],
    icon: "✅"
  },
  {
    id: 6,
    title: "Launch & Deployment",
    subtitle: "Successful Project Rollout",
    description: [
      "Platform deployment and go-live",
      "User training and onboarding",
      "Technical support and monitoring",
      "Performance tracking and reporting"
    ],
    icon: "🚀"
  },
  {
    id: 7,
    title: "Long-term Partnership",
    subtitle: "Continuous Growth Together",
    description: [
      "Ongoing platform maintenance",
      "Feature enhancements and updates",
      "Strategic partnership development",
      "Continuous improvement initiatives"
    ],
    icon: "🤝"
  }
];

export const clientCollaborations: ClientCollaboration[] = [
  {
    id: 1,
    name: "BharatBoudhiks",
    organizationType: "Educational Platform",
    collaborationFocus: "Knowledge and learning initiatives",
    projectNature: "Ongoing",
    summary: "Comprehensive digital platform development for educational content delivery and interactive learning experiences",
    highlights: ["Interactive Course Modules", "Real-time Progress Tracking", "Multilingual Content Support"],
    impact: "Empowered 10,000+ students with accessible digital learning materials across various Indian languages.",
    backgroundImage: bharatBg,
    theme: {
      gradient: "linear-gradient(135deg, rgba(59,130,246,0.25) 0%, rgba(255,255,255,0.7) 45%, rgba(16,185,129,0.25) 100%)",
      glow: "rgba(59,130,246,0.35)",
      accent: "#3b82f6"
    }
  },
  {
    id: 2,
    name: "ShyamLal College",
    organizationType: "Higher Education Institution",
    collaborationFocus: "Academic and institutional programs",
    projectNature: "Ongoing",
    summary: "Digital transformation of academic processes and student engagement platforms for enhanced institutional operations",
    highlights: ["Automated Enrollment System", "Faculty Management Portal", "Dynamic Student Dashboards"],
    impact: "Reduced administrative overhead by 40% and improved student communication efficiency significantly.",
    theme: {
      gradient: "linear-gradient(135deg, rgba(14,165,233,0.22) 0%, rgba(255,255,255,0.75) 50%, rgba(147,51,234,0.25) 100%)",
      glow: "rgba(14,165,233,0.35)",
      accent: "#0ea5e9"
    }
  },
  {
    id: 3,
    name: "NTA",
    organizationType: "Government Examination Authority",
    collaborationFocus: "Digital systems and operational support",
    projectNature: "Ongoing",
    summary: "Digital examination management system with secure workflow automation and real-time monitoring capabilities",
    highlights: ["Secure Question Paper Delivery", "Real-time Monitoring Desk", "Automated Result Processing"],
    impact: "Successfully facilitated large-scale examinations for millions of students with enhanced security and transparency.",
    theme: {
      gradient: "linear-gradient(135deg, rgba(30,64,175,0.28) 0%, rgba(255,255,255,0.65) 45%, rgba(249,115,22,0.3) 100%)",
      glow: "rgba(249,115,22,0.35)",
      accent: "#f97316"
    }
  },
  {
    id: 4,
    name: "Eco Clubs for Mission Life",
    organizationType: "Environmental Initiative",
    collaborationFocus: "Awareness, outreach, and engagement programs",
    projectNature: "Ongoing",
    summary: "Nationwide digital platform for environmental awareness campaigns and student engagement across educational institutions",
    highlights: ["Campaign Management System", "Activity Logging App", "Impact Analytics Dashboard"],
    impact: "Engaged 500+ schools in sustainability initiatives, tracking carbon footprint reduction across communities.",
    backgroundImage: ecoBg,
    theme: {
      gradient: "linear-gradient(135deg, rgba(16,185,129,0.28) 0%, rgba(255,255,255,0.7) 50%, rgba(132,204,22,0.3) 100%)",
      glow: "rgba(34,197,94,0.35)",
      accent: "#22c55e"
    }
  }
];
